export default {
    components: {},

    directives: {
        clickOutside: {
            bind: function (element, binding, vnode) {
                element.clickOutsideEvent = function (event) {
                    if (!(element === event.target || element.contains(event.target))) {
                        vnode.context[binding.expression](event);
                    }
                };
                document.body.addEventListener('click', element.clickOutsideEvent);
            },
            unbind: function (element) {
                document.body.removeEventListener('click', element.clickOutsideEvent);
            }
        }
    },

    data() {
        return {
            hasBooking: false,
            bookingRef: null,
            booking: {
                date: null,
                time: null,
                type: null,
                optometrist_name: null,
                branch_name: null,
                branch_address: null,
                user_first_name: null,
                user_last_name: null,
                user_title: null,
                user_email: null,
                user_phone: null,
                user_dob: null
            },
            dropdownOpen: false
        };
    },

    computed: {
        formattedDateLong() {
            if (!this.booking.date || !this.booking.time) return '';
            const dateTitle = this.getDateTitle(this.booking.date);
            const year = new Date(this.booking.date.replace(/-/g, '/')).getFullYear();
            return `${this.booking.time} - ${dateTitle} ${year}`;
        },

        formattedUserName() {
            const first = this.booking.user_first_name || '';
            const last = this.booking.user_last_name || '';
            let title = this.booking.user_title || '';
            
            if (title) {
                title = title.charAt(0).toUpperCase() + title.slice(1);
            }
            
            return `${title} ${first} ${last}`.trim();
        },

        formattedDob() {
            if (!this.booking.user_dob) return '';
            const parts = this.booking.user_dob.split('-');
            if (parts.length === 3) {
                return `${parts[2]}/${parts[1]}/${parts[0]}`;
            }
            return this.booking.user_dob;
        },

        calendarData() {
            return this.generateCalendarData();
        }
    },

    created() {
        this.loadBookingData();
    },

    methods: {
        loadBookingData() {
            const urlParams = new URLSearchParams(window.location.search);
            const bookingRef = urlParams.get('booking_ref');
            
            if (bookingRef) {
                this.bookingRef = bookingRef;
                const storedData = sessionStorage.getItem(bookingRef);
                if (storedData) {
                    try {
                        const parsedData = JSON.parse(storedData);
                        this.booking = {
                            date: parsedData.date || null,
                            time: parsedData.time || null,
                            type: parsedData.type || null,
                            optometrist_name: parsedData.optometrist_name || 'Any Optometrist',
                            branch_name: parsedData.branch_name || '',
                            branch_address: parsedData.branch_address || '',
                            user_first_name: parsedData.user_first_name || '',
                            user_last_name: parsedData.user_last_name || '',
                            user_title: parsedData.user_title || '',
                            user_email: parsedData.user_email || '',
                            user_phone: parsedData.user_phone || '',
                            user_dob: parsedData.user_dob || parsedData.date_of_birth || null
                        };
                        this.hasBooking = true;
                        
                        this.triggerTrackingPixel(bookingRef);
                    } catch (e) {
                        console.error('Failed to parse booking storage data:', e);
                    }
                }
            }
        },

        triggerTrackingPixel(bookingRef) {
            let firedRefs = [];
            try {
                firedRefs = JSON.parse(localStorage.getItem('fired_booking_refs')) || [];
            } catch (e) {
                firedRefs = [];
            }

            if (!Array.isArray(firedRefs)) {
                firedRefs = [];
            }

            if (!firedRefs.includes(bookingRef)) {
                if (typeof gtag === 'function') {
                    gtag('event', 'conversion', { 'send_to': 'AW-969129079/P9PECJrH0dgDEPf4js4D' });
                }
                
                if (typeof fbq === 'function') {
                    fbq('track', 'CompleteRegistration');
                }

                if (typeof ttq === 'function') {
                    ttq.track('CompleteRegistration');
                }

                firedRefs.push(bookingRef);
                localStorage.setItem('fired_booking_refs', JSON.stringify(firedRefs));
            }
        },

        getDateTitle(date) {
            let dateFull = new Date(date.replace(/-/g, '/')),
                dateParts = new Intl.DateTimeFormat('en-AU', { weekday: 'long', day: 'numeric', month: 'long' }).formatToParts(dateFull),
                dateFormatted = `${dateParts.find( d => d.type === 'weekday').value} ${this._generateOrdinalDate(dateParts.find( d => d.type === 'day').value)} ${dateParts.find( d => d.type === 'month').value}`;
            
            return dateFormatted;
        },

        _generateOrdinalDate(date) {
            var s = ["th", "st", "nd", "rd"];
            var v = date % 100;
            return date + (s[(v - 20) % 10] || s[v] || s[0]);
        },

        toggleDropdown() {
            this.dropdownOpen = !this.dropdownOpen;
        },

        closeDropdown() {
            this.dropdownOpen = false;
        },

        downloadIcs() {
            this.closeDropdown();
            if (!this.calendarData.icsContent) return;
            
            const blob = new Blob([this.calendarData.icsContent], { type: 'text/calendar;charset=utf-8;' });
            const link = document.createElement('a');
            const url = URL.createObjectURL(blob);
            link.href = url;
            link.setAttribute('download', 'eye-test-appointment.ics');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            setTimeout(() => URL.revokeObjectURL(url), 100);
        },

        generateCalendarData() {
            if (!this.booking || !this.booking.date || !this.booking.time) return {};
            
            const title = `Eye Test Appointment - 1001 Optometry`;
            
            let timeStr = this.booking.time;
            let dateStr = this.booking.date;
            
            let hours = 0;
            let minutes = 0;
            const match = timeStr.match(/(\d+):(\d+)\s*(AM|PM)?/i);
            if (match) {
                hours = parseInt(match[1]);
                minutes = parseInt(match[2]);
                const meridian = match[3];
                if (meridian) {
                    if (meridian.toUpperCase() === 'PM' && hours < 12) {
                        hours += 12;
                    } else if (meridian.toUpperCase() === 'AM' && hours === 12) {
                        hours = 0;
                    }
                }
            }
            
            const dateParts = dateStr.split('-');
            const year = parseInt(dateParts[0]);
            const month = parseInt(dateParts[1]) - 1;
            const day = parseInt(dateParts[2]);
            
            const startDate = new Date(year, month, day, hours, minutes, 0);
            const endDate = new Date(startDate.getTime() + 30 * 60000);
            
            const formatICSDate = (d) => {
                const pad = (n) => String(n).padStart(2, '0');
                return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())}T${pad(d.getHours())}${pad(d.getMinutes())}${pad(d.getSeconds())}`;
            };

            const formatICSDateUTC = (d) => {
                const pad = (n) => String(n).padStart(2, '0');
                return `${d.getUTCFullYear()}${pad(d.getUTCMonth() + 1)}${pad(d.getUTCDate())}T${pad(d.getUTCHours())}${pad(d.getUTCMinutes())}${pad(d.getUTCSeconds())}Z`;
            };
            
            const startICS = formatICSDate(startDate);
            const endICS = formatICSDate(endDate);
            
            const locationName = this.booking.branch_name || '';
            const locationAddress = this.booking.branch_address || '';
            const locationFull = `${locationName}, ${locationAddress}`.trim();
            
            const description = `Eye Test Appointment\n` +
                `Type: ${this.booking.type}\n` +
                `Optometrist: ${this.booking.optometrist_name}\n` +
                `Location: ${locationFull}\n\n` +
                `Need assistance? Phone: (02) 9439 9912, Email: contactus@1001optical.com.au`;
                
            const branchNameLower = locationName.toLowerCase();
            let ctz = 'Australia/Sydney';
            if (branchNameLower.includes('qld') || branchNameLower.includes('queensland') || locationAddress.toLowerCase().includes('qld')) {
                ctz = 'Australia/Brisbane';
            } else if (branchNameLower.includes('vic') || branchNameLower.includes('victoria') || locationAddress.toLowerCase().includes('vic')) {
                ctz = 'Australia/Melbourne';
            }
            
            const googleUrl = `https://calendar.google.com/calendar/render?action=TEMPLATE` +
                `&text=${encodeURIComponent(title)}` +
                `&dates=${startICS}/${endICS}` +
                `&details=${encodeURIComponent(description)}` +
                `&location=${encodeURIComponent(locationFull)}` +
                `&ctz=${ctz}`;
                
            const formatOutlookDate = (d) => {
                const pad = (n) => String(n).padStart(2, '0');
                return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
            };
            const startOutlook = formatOutlookDate(startDate);
            const endOutlook = formatOutlookDate(endDate);
            
            const outlookUrl = `https://outlook.live.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent` +
                `&subject=${encodeURIComponent(title)}` +
                `&startdt=${startOutlook}` +
                `&enddt=${endOutlook}` +
                `&body=${encodeURIComponent(description)}` +
                `&location=${encodeURIComponent(locationFull)}`;
                
            const office365Url = `https://outlook.office.com/calendar/0/deeplink/compose?path=/calendar/action/compose&rru=addevent` +
                `&subject=${encodeURIComponent(title)}` +
                `&startdt=${startOutlook}` +
                `&enddt=${endOutlook}` +
                `&body=${encodeURIComponent(description)}` +
                `&location=${encodeURIComponent(locationFull)}`;
                
            const icsContent = [
                'BEGIN:VCALENDAR',
                'VERSION:2.0',
                'PRODID:-//1001 Optometry//Eye Test Appointment//EN',
                'BEGIN:VEVENT',
                `UID:booking-${this.bookingRef || Date.now()}@1001optometry.com.au`,
                `DTSTAMP:${formatICSDateUTC(new Date())}`,
                `DTSTART:${startICS}`,
                `DTEND:${endICS}`,
                `SUMMARY:${title}`,
                `DESCRIPTION:${description.replace(/\n/g, '\\n')}`,
                `LOCATION:${locationFull}`,
                'END:VEVENT',
                'END:VCALENDAR'
            ].join('\n');
            
            return {
                googleUrl,
                outlookUrl,
                office365Url,
                icsContent
            };
        }
    }
};
